function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e5) { throw _e5; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e6) { didErr = true; err = _e6; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import ve from "../models/braze-event.js";
import _t from "../models/identifier.js";
import { isArray as w, keys as y, validateValueIsFromEnum as ta, values as Rt } from "../util/code-utils.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import { User } from "../User/index.js";
import ro from "../util/browser-detector.js";
import { getErrorMessage as si } from "../util/error-utils.js";
export var STORAGE_KEYS = {
  iu: {
    su: "ab.storage.userId",
    Qo: "ab.storage.deviceId",
    zl: "ab.storage.sessionId"
  },
  bs: {
    ec: "ab.test",
    tE: "ab.storage.events",
    eE: "ab.storage.attributes",
    sE: "ab.storage.attributes.anonymous_user",
    Xa: "ab.storage.device",
    qu: "ab.storage.sdk_metadata",
    Au: "ab.storage.session_id_for_cached_metadata",
    Kn: "ab.storage.pushToken",
    Be: "ab.storage.newsFeed",
    Ge: "ab.storage.lastNewsFeedRefresh",
    Ct: "ab.storage.cardImpressions",
    fl: "ab.storage.serverConfig",
    rE: "ab.storage.triggers",
    oE: "ab.storage.triggers.ts",
    Wl: "ab.storage.messagingSessionStart",
    wi: "ab.storage.cc",
    gi: "ab.storage.ccLastFullSync",
    yi: "ab.storage.ccLastCardUpdated",
    _u: "ab.storage.globalRateLimitCurrentTokenCount",
    Ju: "ab.storage.dynamicRateLimitCurrentTokenCount",
    ot: "ab.storage.ccClicks",
    vt: "ab.storage.ccImpressions",
    gt: "ab.storage.ccDismissals",
    nE: "ab.storage.lastDisplayedTriggerTimesById",
    aE: "ab.storage.lastDisplayedTriggerTime",
    iE: "ab.storage.triggerFireInstancesById",
    qh: "ab.storage.signature",
    Fi: "ab.storage.brazeSyncRetryCount",
    Di: "ab.storage.sdkVersion",
    Yi: "ab.storage.ff",
    we: "ab.storage.ffImpressions",
    ke: "ab.storage.ffLastRefreshAt",
    xe: "ab.storage.ff.sessionId",
    EE: "ab.storage.lastReqToEndpoint",
    lE: "ab.storage.requestAttempts",
    cn: "ab.storage.deferredIam",
    xu: "ab.storage.lastSdkReq",
    SE: "ab.storage.alias",
    gs: "ab.storage.banners",
    xs: "ab.storage.banners.impressions",
    ys: "ab.storage.banners.sessionId"
  },
  ae: "ab.optOut"
};

var ne = /*#__PURE__*/function () {
  function ne(t, e) {
    _classCallCheck(this, ne);

    this._E = t, this.uE = e, this._E = t, this.uE = e;
  }

  _createClass(ne, [{
    key: "Ua",
    value: function Ua(t) {
      var e = y(STORAGE_KEYS.iu),
          s = new ne.ne(t);

      var _iterator = _createForOfIteratorHelper(e),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t2 = _step.value;
          s.remove(STORAGE_KEYS.iu[_t2]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "uu",
    value: function uu(t, e) {
      var s = null;
      null != e && e instanceof _t && (s = e.Bs()), this._E.store(t, s);
    }
  }, {
    key: "cE",
    value: function cE(t) {
      var e = this.tu(t);
      null != e && (e.Al = new Date().valueOf(), this.uu(t, e));
    }
  }, {
    key: "tu",
    value: function tu(t) {
      var e = this._E.gr(t),
          s = function (t) {
        var e;

        try {
          e = JSON.parse(t);
        } catch (t) {
          e = null;
        }

        return e;
      }(e);

      var r;
      if (s) r = _t.Qn(s) || null, r && this.uu(t, r);else {
        var _s = _t.TE(e);

        r = _t.Qn(_s) || null, _s !== e && r && this.uu(t, r);
      }
      return r;
    }
  }, {
    key: "Ml",
    value: function Ml(t) {
      this._E.remove(t);
    }
  }, {
    key: "Wa",
    value: function Wa() {
      var t = y(STORAGE_KEYS.iu);
      var e;

      var _iterator2 = _createForOfIteratorHelper(t),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var s = _step2.value;
          e = this.tu(STORAGE_KEYS.iu[s]), null != e && this.uu(STORAGE_KEYS.iu[s], e);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "Eo",
    value: function Eo(t) {
      var e;
      if (null == t || 0 === t.length) return !1;
      e = w(t) ? t : [t];
      var s = this.uE.gr(STORAGE_KEYS.bs.tE);
      null != s && w(s) || (s = []);

      for (var _t3 = 0; _t3 < e.length; _t3++) {
        s.push(e[_t3].Bs());
      }

      return this.uE.store(STORAGE_KEYS.bs.tE, s);
    }
  }, {
    key: "Il",
    value: function Il(t) {
      return null != t && this.Eo([t]);
    }
  }, {
    key: "hE",
    value: function hE() {
      var t = this.uE.gr(STORAGE_KEYS.bs.tE);
      this.uE.remove(STORAGE_KEYS.bs.tE), null == t && (t = []);
      var e = [];
      var s = !1,
          r = null;
      if (w(t)) for (var _s2 = 0; _s2 < t.length; _s2++) {
        ve.AE(t[_s2]) ? e.push(ve.Qn(t[_s2])) : r = _s2;
      } else s = !0;

      if (s || null != r) {
        var o = "Stored events could not be deserialized as Events";
        s && (o += ", was " + Object.prototype.toString.call(t) + " not an array"), null != r && (o += ", value at index " + r + " does not look like an event"), o += ", serialized values were of type " + _typeof(t) + ": " + JSON.stringify(t), e.push(new ve(null, d.Li, new Date().valueOf(), null, {
          e: o
        }));
      }

      return e;
    }
  }, {
    key: "js",
    value: function js(t, e) {
      return !!ta(STORAGE_KEYS.bs, t, "StorageManager cannot store object.", "STORAGE_KEYS.OBJECTS") && this.uE.store(t, e);
    }
  }, {
    key: "ps",
    value: function ps(t) {
      return !!ta(STORAGE_KEYS.bs, t, "StorageManager cannot retrieve object.", "STORAGE_KEYS.OBJECTS") && this.uE.gr(t);
    }
  }, {
    key: "Ls",
    value: function Ls(t) {
      return !!ta(STORAGE_KEYS.bs, t, "StorageManager cannot remove object.", "STORAGE_KEYS.OBJECTS") && (this.uE.remove(t), !0);
    }
  }, {
    key: "clearData",
    value: function clearData() {
      var t = y(STORAGE_KEYS.iu),
          e = y(STORAGE_KEYS.bs);

      for (var _e = 0; _e < t.length; _e++) {
        var s = t[_e];

        this._E.remove(STORAGE_KEYS.iu[s]);
      }

      for (var _t4 = 0; _t4 < e.length; _t4++) {
        var _s3 = e[_t4];
        this.uE.remove(STORAGE_KEYS.bs[_s3]);
      }
    }
  }, {
    key: "RE",
    value: function RE(t) {
      return t || STORAGE_KEYS.bs.sE;
    }
  }, {
    key: "$u",
    value: function $u(t) {
      var e = this.uE.gr(STORAGE_KEYS.bs.eE);
      null == e && (e = {});
      var s = this.RE(t[User.Cu]),
          r = e[s];

      for (var o in t) {
        o !== User.Cu && (null == e[s] || r && null == r[o]) && this.mu(t[User.Cu], o, t[o]);
      }
    }
  }, {
    key: "mu",
    value: function mu(t, e, s) {
      var r = this.uE.gr(STORAGE_KEYS.bs.eE);
      null == r && (r = {});
      var o = this.RE(t);
      var n = r[o];

      if (null == n && (n = {}, null != t && (n[User.Cu] = t)), e === User.lu) {
        null == n[e] && (n[e] = {});

        for (var _t5 in s) {
          n[e][_t5] = s[_t5];
        }
      } else n[e] = s;

      return r[o] = n, this.uE.store(STORAGE_KEYS.bs.eE, r);
    }
  }, {
    key: "gE",
    value: function gE() {
      var t = this.uE.gr(STORAGE_KEYS.bs.eE);
      this.uE.remove(STORAGE_KEYS.bs.eE);
      var e = [];

      for (var s in t) {
        null != t[s] && e.push(t[s]);
      }

      return e;
    }
  }, {
    key: "ru",
    value: function ru(t) {
      var e = this.uE.gr(STORAGE_KEYS.bs.eE);

      if (null != e) {
        var _s4 = this.RE(null),
            _r = e[_s4];

        null != _r && (e[_s4] = void 0, this.uE.store(STORAGE_KEYS.bs.eE, e), _r[User.Cu] = t, this.$u(_r));
      }

      var s = this.tu(STORAGE_KEYS.iu.zl);
      var r = null;
      null != s && (r = s.eu);
      var o = this.hE();
      if (null != o) for (var _e2 = 0; _e2 < o.length; _e2++) {
        var _s5 = o[_e2];
        null == _s5.userId && _s5.sessionId == r && (_s5.userId = t), this.Il(_s5);
      }
    }
  }, {
    key: "OE",
    value: function OE() {
      return this.uE.IE;
    }
  }]);

  return ne;
}();

export { ne as default };
ne.rc = /*#__PURE__*/function () {
  function _class(t) {
    _classCallCheck(this, _class);

    this.yn = t, this.yn = t, this.IE = ro.dE() ? 3 : 10;
  }

  _createClass(_class, [{
    key: "fE",
    value: function fE(t) {
      return t + "." + this.yn;
    }
  }, {
    key: "store",
    value: function store(t, e) {
      var s = {
        v: e
      };

      try {
        return localStorage.setItem(this.fE(t), JSON.stringify(s)), !0;
      } catch (t) {
        return N.info("Storage failure: " + si(t)), !1;
      }
    }
  }, {
    key: "gr",
    value: function gr(t) {
      try {
        var e = null;
        var s = localStorage.getItem(this.fE(t));
        return null != s && (e = JSON.parse(s)), null == e ? null : e.v;
      } catch (t) {
        return N.info("Storage retrieval failure: " + si(t)), null;
      }
    }
  }, {
    key: "remove",
    value: function remove(t) {
      try {
        localStorage.removeItem(this.fE(t));
      } catch (t) {
        return N.info("Storage removal failure: " + si(t)), !1;
      }
    }
  }]);

  return _class;
}(), ne.ac = /*#__PURE__*/function () {
  function _class2() {
    _classCallCheck(this, _class2);

    this.bE = {}, this.KE = 5242880, this.IE = 3;
  }

  _createClass(_class2, [{
    key: "store",
    value: function store(t, e) {
      var s = {
        value: e
      },
          r = this.mE(e);
      return r > this.KE ? (N.info("Storage failure: object is ≈" + r + " bytes which is greater than the max of " + this.KE), !1) : (this.bE[t] = s, !0);
    }
  }, {
    key: "mE",
    value: function mE(t) {
      var e = [],
          s = [t];
      var r = 0;

      for (; s.length;) {
        var _t6 = s.pop();

        if ("boolean" == typeof _t6) r += 4;else if ("string" == typeof _t6) r += 2 * _t6.length;else if ("number" == typeof _t6) r += 8;else if ("object" == _typeof(_t6) && -1 === e.indexOf(_t6)) {
          var _r2 = void 0,
              o = void 0;

          e.push(_t6);

          for (var _e3 in _t6) {
            o = _t6, _r2 = _e3, s.push(o[_r2]);
          }
        }
      }

      return r;
    }
  }, {
    key: "gr",
    value: function gr(t) {
      var e = this.bE[t];
      return null == e ? null : e.value;
    }
  }, {
    key: "remove",
    value: function remove(t) {
      this.bE[t] = null;
    }
  }]);

  return _class2;
}(), ne.ne = /*#__PURE__*/function () {
  function _class3(t, e) {
    _classCallCheck(this, _class3);

    this.yn = t, this.YE = e, this.yn = t, this.NE = this.GE(), this.DE = 576e3, this.YE = !!e;
  }

  _createClass(_class3, [{
    key: "fE",
    value: function fE(t) {
      return null != this.yn ? t + "." + this.yn : t;
    }
  }, {
    key: "GE",
    value: function GE() {
      var t = 0,
          e = document.location.hostname;
      var s = e.split("."),
          r = "ab._gd";

      for (; t < s.length - 1 && -1 === document.cookie.indexOf(r + "=" + r);) {
        t++, e = "." + s.slice(-1 - t).join("."), document.cookie = r + "=" + r + ";domain=" + e + ";";
      }

      return document.cookie = r + "=;expires=" + new Date(0).toUTCString() + ";domain=" + e + ";", e;
    }
  }, {
    key: "se",
    value: function se() {
      var t = new Date();
      return t.setTime(t.getTime() + 60 * this.DE * 1e3), t.getFullYear();
    }
  }, {
    key: "CE",
    value: function CE() {
      var t = Rt(STORAGE_KEYS.iu),
          e = document.cookie.split(";");

      for (var s = 0; s < e.length; s++) {
        var r = e[s];

        for (; " " === r.charAt(0);) {
          r = r.substring(1);
        }

        var o = !1;

        for (var _e4 = 0; _e4 < t.length; _e4++) {
          if (0 === r.indexOf(t[_e4])) {
            o = !0;
            break;
          }
        }

        if (o) {
          var _t7 = r.split("=")[0];
          -1 === _t7.indexOf("." + this.yn) && this.ME(_t7);
        }
      }
    }
  }, {
    key: "store",
    value: function store(t, e) {
      this.CE();
      var s = new Date();
      s.setTime(s.getTime() + 60 * this.DE * 1e3);
      var r = "expires=" + s.toUTCString(),
          o = "domain=" + this.NE;
      var n;
      n = this.YE ? e : encodeURIComponent(e);
      var a = this.fE(t) + "=" + n + ";" + r + ";" + o + ";path=/";
      return a.length >= 4093 ? (N.info("Storage failure: string is " + a.length + " chars which is too large to store as a cookie."), !1) : (document.cookie = a, !0);
    }
  }, {
    key: "gr",
    value: function gr(t) {
      var e = [],
          s = this.fE(t) + "=",
          r = document.cookie.split(";");

      for (var o = 0; o < r.length; o++) {
        var n = r[o];

        for (; " " === n.charAt(0);) {
          n = n.substring(1);
        }

        if (0 === n.indexOf(s)) try {
          var _t8 = void 0;

          _t8 = this.YE ? n.substring(s.length, n.length) : decodeURIComponent(n.substring(s.length, n.length)), e.push(_t8);
        } catch (e) {
          return N.info("Storage retrieval failure: " + si(e)), this.remove(t), null;
        }
      }

      return e.length > 0 ? e[e.length - 1] : null;
    }
  }, {
    key: "remove",
    value: function remove(t) {
      this.ME(this.fE(t));
    }
  }, {
    key: "ME",
    value: function ME(t) {
      var e = t + "=;expires=" + new Date(0).toUTCString();
      document.cookie = e, document.cookie = e + ";path=/";
      var s = e + ";domain=" + this.NE;
      document.cookie = s, document.cookie = s + ";path=/";
    }
  }]);

  return _class3;
}(), ne.tc = /*#__PURE__*/function () {
  function _class4(t, e, s) {
    _classCallCheck(this, _class4);

    this.yn = t, this.pE = [], e && this.pE.push(new ne.ne(t)), s && this.pE.push(new ne.rc(t)), this.pE.push(new ne.ac());
  }

  _createClass(_class4, [{
    key: "store",
    value: function store(t, e) {
      var s = !0;

      for (var r = 0; r < this.pE.length; r++) {
        s = this.pE[r].store(t, e) && s;
      }

      return s;
    }
  }, {
    key: "gr",
    value: function gr(t) {
      for (var e = 0; e < this.pE.length; e++) {
        var s = this.pE[e].gr(t);
        if (null != s) return s;
      }

      return null;
    }
  }, {
    key: "remove",
    value: function remove(t) {
      new ne.ne(this.yn).remove(t);

      for (var e = 0; e < this.pE.length; e++) {
        this.pE[e].remove(t);
      }
    }
  }]);

  return _class4;
}();